import If from "../../../../if"
import Badge from "../../../../badge"
import Tooltip from "../../../../tool-tip"
import { capitalize } from "../../../../../utils"
import { engagementSources } from "../../../../../constants"
import { SubscriptionSource } from "../../../../../../types"

interface EngagementsBadgesProps {
  className?: string
  source: SubscriptionSource
}

const EngagementsBadges = ({ className, source }: EngagementsBadgesProps) => {
  const engagementSource = engagementSources.find(es => es.id === source)
  const sourceLabel = engagementSource?.label ?? capitalize(source)
  const BadgeComponent = engagementSource?.value || Badge.Info // Use a default or fallback component

  return (
    <If
      condition={!!engagementSource?.tooltip}
      then={
        <Tooltip
          toolTipNode={
            <BadgeComponent className={className}>{sourceLabel}</BadgeComponent>
          }
          placement="top"
          text={engagementSource?.tooltip || ""}
        />
      }
      else={
        <BadgeComponent className={className}>{sourceLabel}</BadgeComponent>
      }
    />
  )
}

export default EngagementsBadges
